export const MESSAGE_EXTENSION = {
  AVATAR_UPDATE: 'avatarUpdate',
  CAROUSEL: 'carousel',
  FORM: 'form',
  INFORMATION: 'information',
  MESSAGE_BODIES: 'messageBodies',
  QUICK_REPLIES: 'quickReplies',
} as const;
